<template>
  <div>
    <el-breadcrumb separator="/">
      <el-breadcrumb-item>判读信息</el-breadcrumb-item>
      <el-breadcrumb-item>检测反馈</el-breadcrumb-item>
    </el-breadcrumb>
    <!-- <el-divider></el-divider> -->
    <header>
      <h3>客户信息</h3>
    </header>

    <el-form
      :inline="true"
      :model="query"
      class="demo-form-inline"
      label-position="top"
    >
      <el-row>
        <el-col :span="6">
          <el-form-item label="手机号码">
            <el-input v-model="query.teleNum" placeholder="手机号码"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item label="姓名">
            <el-input v-model="query.name" placeholder="姓名"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item label="检测日期">
            <el-date-picker
              v-model="query.date"
              placeholder="检测日期"
            ></el-date-picker>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item label="检测状态">
            <el-select v-model="query.state"  clearable placeholder="请选择检测状态">
              <el-option v-for="(item,index) in stateList" 
                :label="item.label" 
                :value="item.value" 
                :key="index"
              ></el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item label="阳性数">
            <el-input v-model.number="query.positive" placeholder="阳性数"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item label="临界数">
            <el-input v-model.number="query.borderline" placeholder="临界数"></el-input>
          </el-form-item>
        </el-col>

        <el-col :span="6">
          <el-form-item label="导出开始时间">
            <el-date-picker
              v-model="query.exportBegin"
              placeholder="导出开始时间"
            ></el-date-picker>
          </el-form-item>
        </el-col>

        <el-col :span="6">
          <el-form-item label="导出结束时间">
            <el-date-picker
              v-model="query.exportEnd"
              placeholder="导出结束时间"
            ></el-date-picker>
          </el-form-item>
        </el-col>

      </el-row>
      <el-row>
        <el-col :span="6" :offset="18">
          <el-form-item>
            
            <el-button type="primary" size="medium" @click="search">查询</el-button>
            <el-button type="primary" size="medium" @click="reset">重置</el-button>

            <el-button type="primary" size="medium" @click="dataExport">数据导出</el-button>
            <!-- <el-button type="primary" size="medium" @click="print"
              >打印</el-button
            > -->
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>

    <el-table
      v-loading = "pictLoading"
      element-loading-background = "rgba(0, 0, 0, 0.2)"
      element-loading-text = "数据正在加载中"
      element-loading-spinner = "el-icon-loading"
      ref="multipleTable"
      :data="tableData"
      tooltip-effect="dark"
      fit
      highlight-current-row
      style="width: 100%"
      @selection-change="handleSelectionChange"
      border
    >
      <el-table-column type="selection" width="55"></el-table-column>
      <el-table-column prop="userTeleNum" label="手机号码"></el-table-column>
      <el-table-column prop="name" label="姓名"> </el-table-column>
      <el-table-column prop="gender" label="性别"> </el-table-column>
      <el-table-column prop="age" label="年龄" :formatter="ageFormatter">
      </el-table-column>
      <el-table-column
        prop="state"
        label="检测状态"
        :formatter="stateFormatter"
      ></el-table-column>
      <el-table-column prop="positive" label="阳性数" ></el-table-column>
      <el-table-column prop="borderline" label="临界数" ></el-table-column>
      <el-table-column prop="arrivalTime" label="到达时间" ></el-table-column>
      <el-table-column label="操作"  width="250">
        <template slot-scope="scope">
          <el-button size="mini" type="success" @click="checkDetail(scope.row)"
            >反馈</el-button
          >
        </template>
      </el-table-column>
    </el-table>

    <div class="block">
      <el-pagination
        fit
        background
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="pagination.currentPage"
        :page-sizes="pagination.pageSizeList"
        :page-size="pagination.pageSize"
        :total="pagination.totalNumber"
        layout="total, sizes, prev, pager, next, jumper"
      >
      </el-pagination>
    </div>
  </div>
</template>

<script>
import Moment, { now } from "moment"
import { ExamStatesValue, ExamStatesLabel, unifiedPagination } from "../../../utils/constants";
import { searchUser } from "../../../api/userService";
import { exportData } from "../../../api/userExamService";
import {
  Formatter_examStatesFormatter,
  Formatter_ageFormatter,
} from "../../../utils/formatter";

export default {
  name: "callCenter",
  components: {},
  data() {
    return {
      //table Loading
      pictLoading:true,
      //查询字段
      query: {
        teleNum: "",
        name: "",
        date: "",
        state:"",
        positive:"",
        borderline:"",
        exportBegin:Moment(now()).format("YYYY-MM-DD"),
        exportEnd:""
      },
      stateRange: {
        fromStat:ExamStatesValue.FEED_BACK_80,
        toStat:ExamStatesValue.FINISHED,
      },
      //检测状态列表
      stateList:[
        {
          value:ExamStatesValue.FEED_BACK_80,
          label:ExamStatesLabel.FEED_BACK_80
        },
        {
          value:ExamStatesValue.FINISHED,
          label:ExamStatesLabel.FINISHED
        }
      ],
      //表格数据
      tableData: [],
      multipleSelection: [],
      pagination: unifiedPagination,
      clientInfo: {},
    };
  },
  methods: {
    stateFormatter(row) {
      return Formatter_examStatesFormatter(row.state);
    },
    ageFormatter(row) {
      return Formatter_ageFormatter(row.birthDate);
    },
    _searchUser(){
      //path parameters
      let params = this.pagination.pageNum + '/' + this.pagination.pageSize;
      //body parameters
      let data = {};
      if(this.query.teleNum != ""){
        data.teleNum = this.query.teleNum
      }
      if(this.query.name != ""){
        data.name = this.query.name
      }
      if(this.query.date != ""){
        console.log( this.query.date )
        data.date = Moment(this.query.date).format("YYYY-MM-DD HH:MM:SS")
      }
      if(this.query.positive != ""){
        data.positive = this.query.positive
      }
      if(this.query.borderline != ""){
        data.borderline = this.query.borderline
      }
      if(this.query.state){
        data.fromStat = this.query.state
        data.toStat = this.query.state;
      }else{
        data.fromStat = this.stateRange.fromStat
        data.toStat = this.stateRange.toStat
      }

      console.log(data)

      searchUser( params , data )
      .then(res => {
        if(res.success) {
          //初始化分页
          this.pagination.pageNum = 1
          this.pagination.currentPage = 1
          this.pagination.totalNumber = res.totalNumber
          this.pagination.totalPage = res.totalPage
          //初始化表格数据
          this.tableData = res.data;
        }
        else{
          this.$message({ message: res.description, type:"error"})
        }
          setTimeout(this.loadingSuccess,800);

      })
      .catch(e => {
          setTimeout(this.loadingSuccess,800);

        alert(e)
      })
    },
    //table Loading
    loadingSuccess(){
      this.pictLoading = false
    },
    print() {},
    search() {
      this._searchUser();
    },
    dataExport() {
      let beginParam = "";
      let endParam = "";
      if(!this.query.exportBegin) {
        beginParam = "1970-1-1";
      } else {
        beginParam = Moment(this.query.exportBegin).format("YYYY-MM-DD");
      }

      if(!this.query.exportEnd) {
        endParam = "2970-1-1";
      }else {
        endParam = Moment(this.query.exportEnd).format("YYYY-MM-DD")
      }

      let params = beginParam + '/' + endParam;
      exportData(params).then((res) => {
            let url = window.URL.createObjectURL(new Blob([res]));
            let link = document.createElement('a');
            link.style.display = 'none';
            link.href = url;
            link.setAttribute('download', 'exported.xlsx');
            document.body.appendChild(link);
            link.click();
        });
    },
    reset() {
      this.query.teleNum = "";
      this.query.name = "";
      this.query.date = "";
      this.query.state = "";
      this.query.positive = "";
      this.query.borderline = "";
      this.query.exportBegin = Moment(now()).format("YYYY-MM-DD");
      this.query.exportEnd = "";
      this._searchUser();
    },
    toggleSelection(rows) {
      if (rows) {
        rows.forEach((row) => {
          this.$refs.multipleTable.toggleRowSelection(row);
        });
      } else {
        this.$refs.multipleTable.clearSelection();
      }
    },
    handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    handleSizeChange(val) {
      console.log(`每页 ${val} 条`);
      this.pagination.pageSize = val;
      this._searchUser();
    },
    handleCurrentChange(val) {
      console.log(`当前页: ${val}`);
      this.pagination.pageNum = val;
      this._searchUser();
    },
    checkDetail(row) {
      this.$router.push({
        path: "/callCenter/clientInfo/view",
        query: { teleNum: row.userTeleNum, examUuid: row.examUuid },
      });
    },
  },
  created() {
    this._searchUser();
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
div.block {
  margin-top: 25px;
}

header {
  margin-top: 30px;
}
</style>
